import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import common from 'src/js/modules/common';
import OptionSection from 'src/js/modules/common/components/option-section';

const {
  components: { ModalWithPanels },
} = common;

const { Stack, ValueInput, HorizontalStack, Heading, Box, Divider } = designSystem;

const DIALOG_CONFIG = {
  WIDTH: 358,
  HEIGHT: 304,
  OFFSET_Y: 100,
  OFFSET_X: 500,
};

const TextCustomSpacingDialog = ({
  state,
  captions,
  onLineHeightChange,
  onMarginTopChange,
  onMarginBottomChange,
  onSubmit,
  onCancel,
}) => (
  <ModalWithPanels
    captions={captions}
    width={DIALOG_CONFIG.WIDTH}
    height={DIALOG_CONFIG.HEIGHT}
    offsetY={DIALOG_CONFIG.OFFSET_Y}
    offsetX={DIALOG_CONFIG.OFFSET_X}
    withHorizontalPadding={false}
    onSubmit={onSubmit}
    onOverlayClick={onSubmit}
    onCancel={onCancel}
  >
    <Stack gap="spacing-m">
      <Box paddingLeft="spacing-m" paddingRight="spacing-m">
        <OptionSection title={captions.lineHeight} bold>
          <ValueInput
            value={state.lineHeight}
            min={0}
            max={10}
            size="small"
            align="left"
            appearance="gray"
            bold
            onChange={onLineHeightChange}
            onInputChange={onLineHeightChange}
          />
        </OptionSection>
      </Box>
      <Divider />
      <Box paddingLeft="spacing-m" paddingRight="spacing-m">
        <Box paddingBottom="spacing-2-xs">
          <Heading type="heading-6">{captions.paragraphSpacing}</Heading>
        </Box>
        <HorizontalStack align="space-between">
          <OptionSection title={captions.top}>
            <ValueInput
              value={state.marginTop}
              min={0}
              max={999}
              size="small"
              align="left"
              appearance="gray"
              bold
              onChange={onMarginTopChange}
              onInputChange={onMarginTopChange}
            />
          </OptionSection>
          <OptionSection title={captions.bottom}>
            <ValueInput
              value={state.marginBottom}
              min={0}
              max={999}
              size="small"
              align="left"
              appearance="gray"
              bold
              onChange={onMarginBottomChange}
              onInputChange={onMarginBottomChange}
            />
          </OptionSection>
        </HorizontalStack>
      </Box>
    </Stack>
  </ModalWithPanels>
);

TextCustomSpacingDialog.propTypes = {
  state: PropTypes.shape({
    lineHeight: PropTypes.number,
    marginTop: PropTypes.number,
    marginBottom: PropTypes.number,
  }).isRequired,
  captions: PropTypes.shape({
    title: PropTypes.string,
    submitButton: PropTypes.string,
    cancelButton: PropTypes.string,
    lineHeight: PropTypes.string,
    paragraphSpacing: PropTypes.string,
    top: PropTypes.string,
    bottom: PropTypes.string,
  }).isRequired,
  onLineHeightChange: PropTypes.func.isRequired,
  onMarginTopChange: PropTypes.func.isRequired,
  onMarginBottomChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default TextCustomSpacingDialog;
